<template>
  <v-footer v-if="display.mobile.value" class="hidden-md-and-up" app>
    <v-bottom-navigation class="mb-n5 pa-2 text-grey">
      <div class="mb-4 pa-1">
        <v-list class="d-flex mx-auto justify-space-between">
          <v-list-item
            v-for="(item, index) in bottomNav"
            :key="index"
            :value="item.name"
            :to="item.route"
            :class="['mx-n1', 'mt-n4', 'pb-2', 'text-grey']"
            @click="toggle(item)"
          >
            <template v-slot:title>
              <div></div>
              <div class="text-center">
                <v-icon size="x-small">{{ item.icon }}</v-icon>
              </div>
              <div class="text-caption pb-1">{{ item.name }}</div>
            </template>
          </v-list-item>
        </v-list>
      </div>
    </v-bottom-navigation>

    <v-dialog v-model="menuActive" width="auto" class="ma-2">
      <v-card class="pa-4" width="300">
        <v-row no-gutters>
          <v-col cols="12" v-if="!loggedInUser">
            <v-btn
              variant="tonal"
              color="error"
              class="text-caption mr-10"
              @click="loginOrSignup"
              block
            >
              Login or Signup
            </v-btn>

            <v-dialog v-model="showLoginDialog" width="380">
              <v-card
                :class="display.mobile.value ? 'ml-n3' : ''"
                :width="display.mobile.value ? '340' : '900'"
              >
                <auth-component />
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="12" v-else>
            <v-card class="ma-n3 mt-2" elevation="0">
              <div class="text-center mt-2">
                <v-avatar color="error" size="70"></v-avatar>
                <div class="my-4 font-weight-black text-caption">
                  {{ loggedInUser.fullName }}
                  <div>{{ loggedInUser.email }}</div>
                </div>
              </div>

              <div class="mx-2">
                <v-row class="ma-1">
                  <v-col cols="6" v-for="(menu, i) in belowLogout" :key="i">
                    <v-card
                      align="center"
                      class="rounded-lg pa-5 bg-grey-lighten-4 menu-icon-mobile"
                      elevation="0"
                      @click="toggle(menu)"
                    >
                      <v-icon
                        color="primary"
                        :icon="menu.icon"
                        size="x-large"
                      ></v-icon>
                      <div
                        class="mt-2 text-center text-primary font-weight-black text-caption"
                      >
                        {{ menu.name }}
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <v-divider class="my-2" />

<div class="mx-2">
  <v-card class="rounded-lg pa-0 bg-grey-lighten-4" elevation="0">
    <v-list
      class="settings-list"
      density="comfortable"
      v-model:opened="opened"
      :lines="false"
    >
      <!-- Profile group -->
      <v-list-group value="Profile">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi-account-circle-outline"
            title="Profile"
          />
        </template>

        <v-list-item
          prepend-icon="mdi-briefcase-account-outline"
          title="Recruiter Profile"
          @click="go('recruiterProfile')"
        />
        <v-list-item
          prepend-icon="mdi-briefcase-outline"
          title="Jobs Dashboard"
          @click="go('jobsDashboard')"
        />
        <v-list-item
          prepend-icon="mdi-account-search-outline"
          title="Candidate Search"
          @click="go('candidateSearch')"
        />
      </v-list-group>

      <!-- Account group (open by default like the screenshot) -->
      <v-list-group value="Account">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi-cog-outline"
            title="Account"
          />
        </template>

        <v-list-item
          prepend-icon="mdi-phone-outline"
          title="Phone numbers"
          @click="go('phoneNumbers')"
        />
        <v-list-item
          prepend-icon="mdi-shield-outline"
          title="Security"
          @click="go('security')"
        />
      </v-list-group>
    </v-list>
  </v-card>
</div>


              </div>

              <v-card-actions color="blue">
                <v-btn
                  color="blue"
                  @click="handleLogout"
                  prepend-icon="mdi-logout-variant"
                  variant="outlined"
                  block
                >
                  Logout
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-footer>
</template>

<script setup>
import { ref, computed } from "vue";
import { useDisplay } from "vuetify";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import AuthComponent from "@/components/auth/authComponent.vue";

const display = useDisplay();
const store = useStore();
const router = useRouter();

// State
const menuActive = ref(false);
const showLoginDialog = ref(false);

// Computed
const loggedInUser = computed(() => store.state.auth.user);

// Navigation items
const bottomNav = [
  { name: "Home", route: "/", icon: "mdi-home" },
  {
    name: "Searches",
    route: '/my-searches',
    slug: "mySearches",
    icon: "mdi-feature-search-outline",
    menu: "search",
  },
  {
    name: "Post an Ad",
    route: "",
    slug: "placeAd",
    icon: "mdi-plus-circle-outline",
  },
  { name: "Chats", route: "/chats", slug: "chatMe", icon: "mdi-message-text" },
  { name: "Menu", route: "", icon: "mdi-menu", menu: "menu" },
];

const belowLogout = [
  { name: "Notification", route: "/notifications", slug: "notifyMe", icon: "mdi-bell" },
  {
    name: "My Ads",
    route: "/my-ads-listings",
    slug: "myAds",
    icon: "mdi-view-list-outline",
  },
  {
    name: "Favorites",
    route: "/favorites",
    slug: "favorites",
    icon: "mdi-heart-outline",
  },

   {
    name: "Searches",
    route: '/my-searches',
    slug: "mySearches",
    icon: "mdi-feature-search-outline",
  },
];

// Methods
const loginOrSignup = () => {
  if (!loggedInUser.value) {
    showLoginDialog.value = true;
  }
};

const handleLogout = () => {
  menuActive.value = false;
  store.commit("logout");
  store.dispatch("resetInactivityTimeout");
  store.dispatch("auth/logout");
  router.push("/");
  store.dispatch("alert/success", "Logout Successfully");
};

const placeAd = () => {
  !loggedInUser.value
    ? router.push("/auth-list")
    : router.push("/select-your-city");
};

const notifyMe = () => {
  !loggedInUser.value
    ? router.push("/auth-list")
    : router.push("/notifications");
};

const myChats = () => {
  !loggedInUser.value ? router.push("/auth-list") : router.push("/chats");
};

const myAds = () => {
  !loggedInUser.value ? router.push("/auth-list") : router.push("/my-ads-listings");
};

const myFavorites = () => {
  !loggedInUser.value ? router.push("/auth-list") : router.push("/favorites");
};

const mySearches = () => {
  !loggedInUser.value ? router.push("/auth-list") : router.push('/my-searches');
};

const toggle = (item) => {
  if (item.slug === "placeAd") return placeAd();
  if (item.slug === "notifyMe") return notifyMe();
  if (item.slug === "mySearches") return mySearches();
  if (item.slug === "chatMe") return myChats();
  if (item.slug === "myAds") return myAds();
  if (item.slug && item.slug === "favorites") return myFavorites();

  if ((!item.route && item.menu === "menu") || "search") {
    item.menu === "menu" ? (menuActive.value = !menuActive.value) : null; // searchActive was removed since it wasn't used in template
  }
};


// JS
const opened = ref([]);

/** @type {Record<string, string>} */
const linkRoutes = {
  recruiterProfile: '/ats/profile',
  candidateSearch: '/ats/candidate-search',
  jobsDashboard: '/ats/jobs-dashboard',
  phoneNumbers: '#_',
  security: '#_'
};

const go = (slug) => {
  if (!loggedInUser.value) {
    router.push('/auth-list');
    return;
  }
  const path = linkRoutes[slug];
  if (path) {
    menuActive.value = false;
    router.push(path);
  } else {
    console.warn('[go] Unknown slug:', slug);
  }
};

</script>

<style scoped>
.v-input__icon--append .v-icon {
  color: purple;
}

.custom-card {
  background-color: rgba(0, 0, 0, 0.6);
}

.hover-effect {
  background-color: transparent !important;
  transition: color 0.3s ease;
}

.hover-effect:hover {
  background-color: transparent !important;
  color: blue !important;
}

.v-list-item-title {
  color: inherit;
}

.category-scroll-wrapper {
  display: flex;
  overflow-x: auto;
  padding-bottom: 16px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.category-scroll-wrapper::-webkit-scrollbar {
  display: none;
}

.category-scroll {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  scroll-snap-type: x mandatory;
}

.category-scroll > * {
  flex-shrink: 0;
  scroll-snap-align: start;
}

.v-col[cols="auto"] {
  margin-right: 16px;
}

.ecosystem {
  display: flex;
  align-items: center;
}

@media (max-width: 600px) {
  .header-fluid-container {
    padding-left: 4px;
    padding-right: 4px;
  }
}

.mobile-search-field :deep(.v-field) {
  border-radius: 999px !important;
}
.search-anim-icon-wrap {
  width: 28px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.search-anim-icon {
  width: 22px;
  height: 22px;
  display: block;
}
.drop-enter-active {
  animation: drop-in 500ms ease-out forwards;
}
.drop-leave-active {
  position: absolute;
  animation: fade-out 180ms ease-in forwards;
}
@keyframes drop-in {
  0% {
    transform: translateY(-12px);
    opacity: 0;
  }
  70% {
    transform: translateY(0);
    opacity: 1;
  }
  85% {
    transform: translateY(-2px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes fade-out {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(6px);
  }
}

/* Make nested link text left-aligned and NOT truncated */
.settings-list :deep(.v-list-item-title),
.settings-list :deep(.v-list-item-subtitle) {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  text-align: left !important;
  max-width: 100% !important;
}

/* Ensure content can grow full width */
.settings-list :deep(.v-list-item__content) {
  min-width: 0 !important;
}

/* Reduce child indent so there’s more text room */
.settings-list :deep(.v-list-group__items .v-list-item) {
  margin-inline-start: 8px !important;   /* was 16px */
  padding-inline-start: 8px !important;
}

/* (Optional) Mobile-only: apply the overrides only on small screens */
/*
@media (max-width: 768px) {
  .settings-list :deep(.v-list-item-title),
  .settings-list :deep(.v-list-item-subtitle) { ...same rules... }
}
*/

</style>
